import { Link } from "react-router-dom";

const destinations = [
  { city: "Tokyo", country: "Japan", slug: "tokyo", featured: true },
  { city: "Lisbon", country: "Portugal", slug: "lisbon" },
  { city: "Rome", country: "Italy", slug: "rome" },
  { city: "Paris", country: "France", slug: "paris" },
  { city: "Madrid", country: "Spain", slug: "madrid" },
  { city: "Bali", country: "Indonesia", slug: "bali" },
];

// VOY-480: each card pre-fills an AI search that auto-fires on `/`.
function buildSearchHref(city: string): string {
  const q = encodeURIComponent(`Round trip to ${city}`);
  return `/?q=${q}&mode=ai&autoSearch=true`;
}

export function Destinations() {
  return (
    <section className="sec">
      <div className="section-head">
        <div className="eyebrow"><span className="dot" /> Start a search</div>
        <h2>
          Where to <em>next</em>?
        </h2>
      </div>
      <div className="dest-grid">
        {destinations.map((d, idx) => {
          const isFeatured = !!d.featured;
          // Only eagerly preload the featured (above-the-fold, largest) tile.
          const loading = isFeatured ? "eager" : "lazy";
          const fetchPriority = isFeatured ? "high" : "auto";
          return (
            <Link
              key={d.city}
              className={`dest${isFeatured ? " featured" : ""}`}
              to={buildSearchHref(d.city)}
              aria-label={`Search Voy for trips to ${d.city}, ${d.country}`}
            >
              <picture>
                <source srcSet={`/landing-v6/dest-${d.slug}.avif`} type="image/avif" />
                <img
                  src={`/landing-v6/dest-${d.slug}.jpg`}
                  alt={`${d.city}, ${d.country}`}
                  loading={loading}
                  // @ts-expect-error fetchpriority is valid HTML; React types lag behind
                  fetchpriority={fetchPriority}
                  decoding={idx === 0 ? "sync" : "async"}
                  width={800}
                  height={1067}
                />
              </picture>
              <div className="info">
                <div>
                  <div className="city">{d.city}</div>
                  <div className="country">{d.country}</div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
